import { useAtom } from 'jotai'
import { useCallback } from 'react'

import type { IdentifyingInformation } from '@app/domains/layers/types/layers.types'
import { selectedIdentifyingInformationAtom } from '@app/risk-migration/atoms/riskIdentifyingInformation.atoms'

export function useSelectedIdentifyingInformation(
  potentialIdentifyingInformation: IdentifyingInformation[],
) {
  const [selectedIdentifyingInformation, setSelectedIdentifyingInformation] = useAtom(
    selectedIdentifyingInformationAtom,
  )

  const setIdentifyingInformationForAssetHazard = useCallback(
    (assetType: string, scenario: string, attribute: string) => {
      setSelectedIdentifyingInformation((current) => ({
        ...current,
        [assetType]: {
          ...current[assetType],
          [scenario]: potentialIdentifyingInformation.find((info) => info.property === attribute),
        },
      }))
    },
    [potentialIdentifyingInformation, setSelectedIdentifyingInformation],
  )

  return {
    selectedIdentifyingInformation,
    setIdentifyingInformationForAssetHazard,
  }
}
